var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "q-form",
        { ref: "editForm" },
        [
          _c(
            "c-card",
            {
              staticClass: "cardClassDetailForm",
              attrs: { title: "LBL0003015" },
            },
            [
              _c(
                "template",
                { slot: "card-button" },
                [
                  _c(
                    "q-btn-group",
                    { attrs: { outline: "" } },
                    [
                      _c("c-appr-btn", {
                        ref: "appr-btn",
                        attrs: {
                          name: "vendor-assess-appr-btn",
                          editable: _vm.editable && _vm.isOld && !_vm.disabled,
                          approvalInfo: _vm.approvalInfo,
                        },
                        on: {
                          beforeApprAction: function ($event) {
                            return _vm.saveVendorAssess("appr")
                          },
                          callbackApprAction: _vm.approvalCallback,
                          requestAfterAction: _vm.getDetail,
                        },
                      }),
                      _vm.editable && _vm.isOld && !_vm.disabled
                        ? _c("c-btn", {
                            attrs: { label: "LBLREMOVE", icon: "remove" },
                            on: { btnClicked: _vm.deleteData },
                          })
                        : _vm._e(),
                      _c("c-btn", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.editable && !_vm.disabled,
                            expression: "editable && !disabled",
                          },
                        ],
                        attrs: {
                          url: _vm.saveUrl,
                          isSubmit: _vm.isSave,
                          param: _vm.evaluationData,
                          mappingType: _vm.saveType,
                          label: "LBLSAVE",
                          icon: "save",
                        },
                        on: {
                          beforeAction: function ($event) {
                            return _vm.saveVendorAssess("save")
                          },
                          btnCallback: _vm.saveCallback,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "template",
                { slot: "card-description" },
                [
                  _vm.evaluationData.evaluationGradeName
                    ? _c(
                        "q-chip",
                        {
                          staticStyle: { "vertical-align": "baseline" },
                          attrs: { dense: "", color: "blue-grey-3" },
                        },
                        [
                          _vm._v(" " + _vm._s(_vm.setLabel("LBL0003002"))),
                          _c("q-space"),
                          _c(
                            "q-chip",
                            {
                              attrs: {
                                dense: "",
                                color: _vm.evaluationGradeInfo.attrVal3,
                                "text-color": "white",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.evaluationData.evaluationGradeName
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c("q-tooltip", [
                            _vm._v(_vm._s(_vm.evaluationGradeInfo.description)),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c("template", { slot: "card-detail" }, [
                _c(
                  "div",
                  { staticClass: "col-2" },
                  [
                    _c("c-plant", {
                      attrs: {
                        required: true,
                        disabled: _vm.disabled || _vm.isOld,
                        editable: _vm.editable,
                        type: "edit",
                        name: "plantCd",
                      },
                      on: { datachange: _vm.getResultItem },
                      model: {
                        value: _vm.evaluationData.plantCd,
                        callback: function ($$v) {
                          _vm.$set(_vm.evaluationData, "plantCd", $$v)
                        },
                        expression: "evaluationData.plantCd",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-2" },
                  [
                    _c("c-vendor", {
                      attrs: {
                        disabled: _vm.disabled,
                        editable: _vm.editable,
                        required: true,
                        label: "LBL0003016",
                        name: "vendorCd",
                      },
                      model: {
                        value: _vm.evaluationData.vendorCd,
                        callback: function ($$v) {
                          _vm.$set(_vm.evaluationData, "vendorCd", $$v)
                        },
                        expression: "evaluationData.vendorCd",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-2" },
                  [
                    _c("c-select", {
                      attrs: {
                        required: true,
                        disabled: _vm.disabled,
                        editable: _vm.editable,
                        codeGroupCd: "VENDOR_EVALUATION_KIND_CD",
                        type: "edit",
                        itemText: "codeName",
                        itemValue: "code",
                        name: "vendorEvaluationKindCd",
                        label: "LBL0003001",
                      },
                      model: {
                        value: _vm.evaluationData.vendorEvaluationKindCd,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.evaluationData,
                            "vendorEvaluationKindCd",
                            $$v
                          )
                        },
                        expression: "evaluationData.vendorEvaluationKindCd",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-2" },
                  [
                    _c("c-datepicker", {
                      attrs: {
                        required: true,
                        disabled: _vm.disabled,
                        editable: _vm.editable,
                        range: true,
                        label: "LBL0003003",
                        name: "period",
                      },
                      model: {
                        value: _vm.evaluationData.evaluationPeriod,
                        callback: function ($$v) {
                          _vm.$set(_vm.evaluationData, "evaluationPeriod", $$v)
                        },
                        expression: "evaluationData.evaluationPeriod",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-1" },
                  [
                    _c("c-datepicker", {
                      attrs: {
                        required: true,
                        disabled: _vm.disabled,
                        editable: _vm.editable,
                        type: "year",
                        label: "LBL0003017",
                        name: "evaluationYear",
                      },
                      model: {
                        value: _vm.evaluationData.evaluationYear,
                        callback: function ($$v) {
                          _vm.$set(_vm.evaluationData, "evaluationYear", $$v)
                        },
                        expression: "evaluationData.evaluationYear",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-3" },
                  [
                    _c("c-construnction", {
                      attrs: {
                        disabled: _vm.disabled,
                        editable: _vm.editable,
                        name: "sopConstructionId",
                      },
                      model: {
                        value: _vm.evaluationData.sopConstructionId,
                        callback: function ($$v) {
                          _vm.$set(_vm.evaluationData, "sopConstructionId", $$v)
                        },
                        expression: "evaluationData.sopConstructionId",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-2" },
                  [
                    _c("c-field", {
                      attrs: {
                        required: true,
                        disabled: _vm.disabled,
                        editable: _vm.editable,
                        data: _vm.evaluationData,
                        plantCd: _vm.evaluationData.plantCd,
                        type: "dept_user",
                        label: "LBL0003018",
                        name: "assessUserId",
                      },
                      model: {
                        value: _vm.evaluationData.assessUserId,
                        callback: function ($$v) {
                          _vm.$set(_vm.evaluationData, "assessUserId", $$v)
                        },
                        expression: "evaluationData.assessUserId",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c("c-text", {
                      attrs: {
                        disabled: _vm.disabled,
                        editable: _vm.editable,
                        label: "LBL0003010",
                        name: "remarks",
                      },
                      model: {
                        value: _vm.evaluationData.remarks,
                        callback: function ($$v) {
                          _vm.$set(_vm.evaluationData, "remarks", $$v)
                        },
                        expression: "evaluationData.remarks",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            2
          ),
        ],
        1
      ),
      _c("c-table", {
        ref: "table",
        attrs: {
          title: "LBL0003019",
          editable: _vm.editable && !_vm.disabled,
          columns: _vm.gridSubTotal.columns,
          data: _vm.evaluationData.itemResultSubTotals,
          gridHeightAuto: true,
          columnSetting: false,
          usePaging: false,
          isFullScreen: false,
          isExcelDown: false,
          filtering: false,
          isTop: false,
          hideBottom: true,
        },
        scopedSlots: _vm._u([
          {
            key: "description-front-tr",
            fn: function (props) {
              return [
                props.rowIndex === 0
                  ? [
                      _c(
                        "q-tr",
                        {
                          key: `e_front_${props.rowIndex}`,
                          staticClass:
                            "q-virtual-scroll--with-prev bg-blue-5 vendor-assess-item-sub-total-tr",
                          attrs: { props: props },
                        },
                        [
                          _c("q-td", [
                            _vm._v(
                              " " + _vm._s(_vm.setLabel("LBL0003020")) + " "
                            ),
                          ]),
                          _c("q-td", { staticClass: "text-align-right" }, [
                            _vm._v(
                              " " + _vm._s(_vm.evaluationData.totalScore) + " "
                            ),
                          ]),
                          _c("q-td", { staticClass: "text-align-right" }, [
                            _vm._v(
                              " " + _vm._s(_vm.evaluationData.score) + " "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
      _c(
        "c-table",
        {
          ref: "table",
          attrs: {
            title: "LBL0003021",
            editable: _vm.editable && !_vm.disabled,
            columns: _vm.grid.columns,
            data: _vm.gridItemResults,
            gridHeight: _vm.gridHeight,
            columnSetting: false,
            usePaging: false,
            isFullScreen: false,
            isExcelDown: false,
            filtering: false,
            customTrClass: _vm.customTrClass,
          },
          scopedSlots: _vm._u([
            {
              key: "customArea",
              fn: function ({ props, col }) {
                return [
                  !props.row.subtotal
                    ? [
                        _c("c-number-column", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled || !_vm.editable,
                            col: col,
                            props: props,
                            colorClass: _vm.checkColorClass(props.row),
                          },
                          on: {
                            datachange: function ($event) {
                              return _vm.datachange(props, col)
                            },
                          },
                          model: {
                            value: props.row[col.name],
                            callback: function ($$v) {
                              _vm.$set(props.row, col.name, $$v)
                            },
                            expression: "props.row[col.name]",
                          },
                        }),
                      ]
                    : [_vm._v(" " + _vm._s(props.row[col.name]) + " ")],
                ]
              },
            },
          ]),
        },
        [
          _c(
            "template",
            { slot: "suffixTitle" },
            [
              _c(
                "font",
                { staticStyle: { "font-size": "0.8em", "font-weight": "300" } },
                _vm._l(_vm.scoreItems, function (score, idx) {
                  return _c("q-badge", {
                    key: idx,
                    staticClass: "q-mr-sm",
                    class: score.attrVal1,
                    attrs: { label: score.codeName },
                  })
                }),
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }